// Código de invitación legible: PREFIJO-XXXXXX (prefijo = slug del workspace
// saneado). Lo usan las tres altas que crean workspace_invitaciones a mano:
// paciente desde la ficha (FichaPaciente), paciente desde la agenda
// (Agenda, turno manual) y colaborador (Colaboradores).
export function generarCodigo(slug) {
  const base = (slug || 'juco').toUpperCase().replace(/[^A-Z0-9]/g, '')
  const sufijo = Math.random().toString(36).slice(2, 8).toUpperCase()
  return `${base}-${sufijo}`
}

// Mensajes de error de redimir_invitacion(), compartidos entre el flujo de
// link por mail (App.js) — antes vivían duplicados en UnirseWorkspace.js,
// que se elimina en el Bloque 2.1b (el código tipeado deja de existir).
export const MENSAJE_ERROR_INVITACION = {
  codigo_invalido: 'Esa invitación no existe o ya no es válida.',
  codigo_ya_usado: 'Esa invitación ya fue usada.',
  codigo_vencido: 'Esa invitación venció. Pedí que te reenvíen una nueva.',
  ya_sos_miembro: 'Ya pertenecés a ese espacio.',
  no_autenticado: 'Tu sesión expiró. Volvé a iniciar sesión.'
}
